import styled from 'styled-components';

import { IS_SMALL } from "~/utils/media";
import { Grid } from "~/components/grid";
import { CarouselWrapper } from "~/components/carousel";
import { SmallHeadline } from "~/components/typography";

export const ProductCarouselWrapper = styled.div`
  overflow: hidden;
  margin-bottom: 6rem;

  ${Grid},
  ${CarouselWrapper} {
    overflow: visible;
  }

  ${IS_SMALL} {
    margin-bottom: 4rem;
  }
`;

export const ProductCarouselTitle = styled(Grid)`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 1rem;

  ${SmallHeadline} {
    min-width: 72px;
    margin-top: 0;
    font-size: 0.75rem;
    text-align: right;
    letter-spacing: 1px;
    line-height: 1;
    text-transform: uppercase;

    a {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }

`;
